import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	Button,
	Modal,
	ModalBody,
	Col,
	Row,
	Container,
} from 'reactstrap';

import './EmissoesES.scss';

class EmissoesES extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};
	}

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	render() {
		

		return (
			<Modal
				size="sm"
				id="modal-es"
				centered={true}
				isOpen={this.state.isOpen}
				onClosed={this.props.onClosed}
				backdrop="static">
				<ModalBody>
					<Container>
						<Row>
							<Col className="margin-modal">
								<strong>Para impressão de notas do ES, favor desbloquear os pop-ups do seu navegador.</strong>
							</Col>
						</Row>
						<Row className="justify-content-around">
							<Col xs="auto">
								<Button color="info" onClick={() => this.closeModal()}>
									Fechar
								</Button>
							</Col>
						</Row>
					</Container>
				</ModalBody>
			</Modal>
		);
	}
}

EmissoesES.propTypes = {
	value: PropTypes.object,
	onClosed: PropTypes.func,
};

export default EmissoesES;
